module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/39/assets/images/26ee10479e92a24a2aa8a87bedfd9e96.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_attempts.svg
// module id = fjH/
// module chunks = 0